export const getPhotoUrlBySize = (photo, size) => {
  return photo?.files?.find((file) => file.size === size)?.url;
};
export const findPhotoByCategory = (photos, category) => {
  return photos.find((photo) => photo.category === category);
};
